import { DataSource } from '@/shared/models/data/data-source'
import { OrganisationActivity } from '@/api/generated'
import { SearchRequest } from '@/shared/interfaces/search-request'
import { PageResponse } from '@/shared/interfaces/page-response'
import { Injector } from '@/config/dependency-injection'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { LoaderHelper } from '@/shared/services/loader-helper'
import { FETCH_ORGANISATION_ACTIVITIES } from '@/business/organisation/store/types'

export class OrganisationActivityDataSource extends DataSource<OrganisationActivity> {
  private loaderHelper = Injector.get(LoaderHelper)
  private organisationModule = Injector.get(OrganisationsModule)

  private _items: OrganisationActivity[] = []

  public destroy(): void {
    //
  }

  public fetchData({ page, pageSize }: SearchRequest): Promise<PageResponse<OrganisationActivity>> {
    return this.organisationModule
      .fetchOrganisationActivities({
        organisationId: this.organisationModule.organisationViewModel.organisation.id,
        page,
        pageSize,
      })
      .then(response => {
        this._items = [...this._items, ...response.items]

        return response
      })
  }

  public isLoading(): boolean {
    return this.loaderHelper.isLoading(FETCH_ORGANISATION_ACTIVITIES)
  }

  public get items(): OrganisationActivity[] {
    return this._items
  }
}
